import { Link } from 'react-router-dom';
// import catalogData from '../data/catalogData.json'
import aboutData from '../data/aboutData.json'
// import InventoryItems from '../pages/InventoryItems'

const Home = () => {

    // const featuredItems = catalogData.items.slice(0, 3);

return (
    <>
        {/* <HeroCarousel featuredItems={featuredItems} /> */}
        {/* <InventoryItems/> */}
        {aboutData.company.map((vad) => (
        <div className="container d-flex align-items-center justify-content-center py-5 flex-column" key={vad.id}>
            <h1>Enterprise Resource Planning</h1>
            {/* <p>Please select a product to view items or browse all products.</p> */}
            <Link to="/login" className="btn btn-primary m-4">Login</Link>
            {/* <Link to="/register" className="btn btn-primary">Register</Link> */}
        </div>
        ))}
    </>
);
};

export default Home;